/**
 * lezr_payroll - Payroll Dashboard Component
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api/payroll`;

export const PayrollDashboard = () => {
  const [employees, setEmployees] = useState([]);
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    const fetch = async () => {
      try {
        const [empRes, runsRes] = await Promise.all([
          axios.get(`${API}/employees`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/runs`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);
        setEmployees(empRes.data || []);
        setRuns(runsRes.data || []);
      } catch (e) {
        console.error('Payroll fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [token]);

  if (loading) return <div className="p-6">Loading payroll...</div>;

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">Payroll (lezr_payroll)</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="font-semibold text-lg mb-2">Employees</h2>
          <p className="text-3xl font-bold text-emerald-600">{employees.length}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <h2 className="font-semibold text-lg mb-2">Payroll Runs</h2>
          <p className="text-3xl font-bold text-emerald-600">{runs.length}</p>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <h2 className="font-semibold p-4 border-b">Recent Employees</h2>
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Department</th>
              <th className="text-left p-3">Base Salary</th>
              <th className="text-left p-3">Currency</th>
            </tr>
          </thead>
          <tbody>
            {employees.slice(0, 10).map((e) => (
              <tr key={e.id} className="border-t">
                <td className="p-3">{e.name}</td>
                <td className="p-3">{e.department}</td>
                <td className="p-3">{e.base_salary?.toLocaleString()}</td>
                <td className="p-3">{e.currency}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PayrollDashboard;
